import { create } from 'zustand';
import { api } from '@/core/api/apiClient';
import type { DashboardData } from '@cg-projects/shared';

interface DashboardState {
  data: DashboardData | null;
  loading: boolean;
  error: string | null;
  load: (force?: boolean) => Promise<void>;
}

export const useDashboardStore = create<DashboardState>()((set, get) => ({
  data: null,
  loading: false,
  error: null,
  load: async (force = false) => {
    if (get().loading) return;
    if (get().data && !force) return;
    set({ loading: true, error: null });
    try {
      const data = await api.get<DashboardData>('/dashboard');
      set({ data, loading: false });
    } catch (err) {
      set({ loading: false, error: err instanceof Error ? err.message : 'Failed to load overview.' });
    }
  },
}));
